@if(activeNavPoint && !(activeNavPoint === NavigationPoint.login )) {
    <!--|| activeNavPoint === NavigationPoint.collections_readonly -->
    @if(!isIframeIntegrated) {
<section class="main-header unselectable">

        <section class="navigation">
            @if(user) {
            <nav class="navBar">
                <a class="nav-point" [ngClass]="{'selected' : activeNavPoint === NavigationPoint.home}" routerLink="/">{{'nav.home'| translate}}</a>
                <a class="nav-point"  [ngClass]="{'selected' : activeNavPoint === NavigationPoint.assets}" routerLink="/assets">{{'nav.assets'| translate}}</a>
                <a class="nav-point"  [ngClass]="{'selected' : activeNavPoint === NavigationPoint.collections ||  activeNavPoint === NavigationPoint.collections_details}" routerLink="/collections">{{'nav.collections'| translate}}</a>
            </nav>
            }
        </section>


    <div class="logo-wrapper">
           <div class="logo"></div>
    </div>

    <div class="user-bar">
        <div class="search-bar ">
            @if(!isIframeIntegrated && activeNavPoint && (activeNavPoint ===  NavigationPoint.assets
                || activeNavPoint === NavigationPoint.collections_details
            || activeNavPoint === NavigationPoint.collections_readonly)) {
            <app-search></app-search>
            }
            @if(user && activeNavPoint && activeNavPoint ===  NavigationPoint.home) {
                <app-home-search></app-home-search>
            }
        </div>
        @if(!isIframeIntegrated) {
         <app-user-bar></app-user-bar>
        }
    </div>
</section>
    }

<section class="filter-bar-wrapper unselectable">
    <app-filter-bar></app-filter-bar>
    <app-action-bar></app-action-bar>
   <!-- @if(user) {

    }-->
</section>
}

